// src/ai/prompts/index.ts — plugin-pattern prompt loader.
// Any JSON file in this folder that matches `prompt-schema.json` is picked up automatically.
// To add a new prompt, drop a new JSON file. No code change required.
import disputeResolution from './dispute-resolution.json';
import reviewReply from './review-reply.json';
import sentimentScan from './sentiment-scan.json';
const builtin = [
    disputeResolution,
    reviewReply,
    sentimentScan,
];
export function listPrompts() {
    return builtin;
}
export function getPrompt(id) {
    const p = builtin.find(x => x.id === id);
    if (!p)
        throw new Error(`Unknown prompt: ${id}. Known: ${builtin.map(x => x.id).join(', ')}`);
    return p;
}
/**
 * Substitute {{variable}} placeholders in a prompt body.
 * Unknown variables are left in-place so a developer sees the mistake.
 */
export function interpolate(template, vars) {
    return template.replace(/\{\{(\w+)\}\}/g, (m, k) => (k in vars ? vars[k] : m));
}
